<template>
  <div class="app-container">
    <el-card shadow="never" class="query-card">
      <!-- 筛选条件：report-filter-panel 合并两行，避免单行过长换行时双盒子断层 -->
      <div v-show="showSearch" class="report-filter-panel">
      <el-form :model="query" :inline="true" size="small" class="glass-form">
        <el-form-item :label="$t('common.consumptionDate')">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="small"
            style="width: 280px"
            :range-separator="$t('common.dateRangeSep')"
            :start-placeholder="$t('common.dateStart')"
            :end-placeholder="$t('common.dateEnd')"
            value-format="yyyy-MM-dd"
            :picker-options="datePickerOptions"
            @change="handleDateChange"
          />
        </el-form-item>
        <el-form-item :label="$t('consumption.namingStrategy')">
          <el-select
            v-model="query.strategyId"
            clearable
            filterable
            :placeholder="$t('consumption.namingStrategyPlaceholder')"
            size="small"
            style="width: 200px"
          >
            <el-option v-for="s in strategyList" :key="s.id" :label="s.strategyName" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.bookName')">
          <el-input
            v-model="query.bookName"
            :placeholder="$t('common.bookNameSearchPlaceholder')"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item v-if="!isDataLimited" label="投手">
          <el-select
            v-model="query.userName"
            clearable
            filterable
            placeholder="全部投手"
            size="small"
            style="width: 140px"
          >
            <el-option v-for="name in creatorOptions" :key="name" :label="name" :value="name" />
          </el-select>
        </el-form-item>
        <el-form-item label="账户">
          <el-input
            v-model="query.adAccountId"
            placeholder="账户ID或名称"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="系列">
          <el-input
            v-model="query.campaignKeyword"
            placeholder="系列ID或名称"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
      </el-form>
      <el-form :model="query" :inline="true" size="small" class="glass-form">
        <el-form-item label="广告组">
          <el-input
            v-model="query.adsetKeyword"
            placeholder="广告组ID或名称"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="广告">
          <el-input
            v-model="query.adKeyword"
            placeholder="广告ID或名称"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="text" @click="showMetricFilter = !showMetricFilter">
            {{ showMetricFilter ? '收起筛选' : '指标筛选' }}
            <i :class="showMetricFilter ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">{{ $t('common.search') }}</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">{{ $t('common.reset') }}</el-button>
          <el-button type="warning" plain icon="el-icon-download" size="mini" :loading="exporting" @click="handleExport">导出 Excel</el-button>
        </el-form-item>
      </el-form>
      </div>

      <!-- 指标范围筛选 -->
      <el-form v-show="showMetricFilter" :inline="true" size="small" class="glass-form metric-filter-row">
        <el-form-item label="消耗">
          <el-input-number v-model="query.spendMin" placeholder="最小" size="mini" :controls="false" style="width: 90px" />
          <span class="range-sep">~</span>
          <el-input-number v-model="query.spendMax" placeholder="最大" size="mini" :controls="false" style="width: 90px" />
        </el-form-item>
        <el-form-item label="CTR">
          <el-input-number v-model="ctrMinPct" placeholder="最小" size="mini" :controls="false" :precision="2" style="width: 80px" />
          <span class="range-sep">~</span>
          <el-input-number v-model="ctrMaxPct" placeholder="最大" size="mini" :controls="false" :precision="2" style="width: 80px" />
          <span class="range-unit">%</span>
        </el-form-item>
        <el-form-item label="购物">
          <el-input-number v-model="query.purchasesMin" placeholder="最小" size="mini" :controls="false" :precision="0" style="width: 80px" />
          <span class="range-sep">~</span>
          <el-input-number v-model="query.purchasesMax" placeholder="最大" size="mini" :controls="false" :precision="0" style="width: 80px" />
        </el-form-item>
        <el-form-item label="单次费用">
          <el-input-number v-model="query.costPerPurchaseMin" placeholder="最小" size="mini" :controls="false" style="width: 90px" />
          <span class="range-sep">~</span>
          <el-input-number v-model="query.costPerPurchaseMax" placeholder="最大" size="mini" :controls="false" style="width: 90px" />
        </el-form-item>
        <el-form-item label="购物价值">
          <el-input-number v-model="query.purchaseValueMin" placeholder="最小" size="mini" :controls="false" style="width: 90px" />
          <span class="range-sep">~</span>
          <el-input-number v-model="query.purchaseValueMax" placeholder="最大" size="mini" :controls="false" style="width: 90px" />
        </el-form-item>
        <el-form-item label="ROI">
          <el-input-number v-model="query.roiMin" placeholder="最小" size="mini" :controls="false" :precision="4" style="width: 90px" />
          <span class="range-sep">~</span>
          <el-input-number v-model="query.roiMax" placeholder="最大" size="mini" :controls="false" :precision="4" style="width: 90px" />
        </el-form-item>
      </el-form>

      <!-- 维度切换 Tab -->
      <el-tabs v-model="activeDimension" @tab-click="handleTabChange" style="margin-top: -5px;">
        <el-tab-pane :label="$t('insights.dimAccount')" name="account" />
        <el-tab-pane :label="$t('insights.dimCampaign')" name="campaign" />
        <el-tab-pane :label="$t('insights.dimAdset')" name="adset" />
        <el-tab-pane :label="$t('insights.dimAd')" name="ad" />
        <el-tab-pane :label="$t('insights.dimUser')" name="user" />
      </el-tabs>

      <!-- 数据表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        size="small"
        :header-cell-style="{ background: '#f8fafd', color: '#606266', fontWeight: '600' }"
        @sort-change="handleSortChange"
      >
        <el-table-column type="index" label="#" width="50" align="center" />

        <!-- 账户维度列 -->
        <el-table-column v-if="activeDimension === 'account'" :label="$t('insights.adAccountId')" prop="adAccountId" min-width="140" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'account'" :label="$t('insights.adAccountName')" prop="adAccountName" min-width="160" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'account'" :label="$t('insights.accountBalance')" prop="accountBalance" width="110" align="right" sortable="custom">
          <template slot-scope="{ row }">{{ formatMoney(row.accountBalance) }}</template>
        </el-table-column>

        <!-- 系列维度列 -->
        <el-table-column v-if="activeDimension === 'campaign'" :label="$t('insights.adAccountId')" prop="adAccountId" width="130" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'campaign'" :label="$t('insights.adAccountName')" prop="adAccountName" width="140" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'campaign'" :label="$t('insights.campaignIdCol')" prop="campaignId" min-width="160" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'campaign'" :label="$t('insights.campaignName')" prop="campaignName" min-width="180" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'campaign'" :label="$t('common.bookName')" prop="bookName" min-width="160" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'campaign'" :label="$t('insights.createUserName')" prop="createUserName" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.createUserName || '-' }}</template>
        </el-table-column>

        <!-- 广告组维度列 -->
        <el-table-column v-if="activeDimension === 'adset'" :label="$t('insights.adAccountId')" prop="adAccountId" width="130" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'adset'" :label="$t('insights.adAccountName')" prop="adAccountName" width="140" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'adset'" :label="$t('insights.campaignIdCol')" prop="campaignId" width="140" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'adset'" :label="$t('insights.campaignName')" prop="campaignName" min-width="180" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'adset'" :label="$t('common.bookName')" prop="bookName" min-width="160" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'adset'" :label="$t('insights.createUserName')" prop="createUserName" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.createUserName || '-' }}</template>
        </el-table-column>
        <el-table-column v-if="activeDimension === 'adset'" :label="$t('insights.adsetIdCol')" prop="adsetId" min-width="160" show-overflow-tooltip />

        <!-- 广告维度列 -->
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('insights.adAccountId')" prop="adAccountId" width="120" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('insights.adAccountName')" prop="adAccountName" width="130" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('insights.campaignIdCol')" prop="campaignId" width="130" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('insights.campaignName')" prop="campaignName" min-width="180" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('common.bookName')" prop="bookName" min-width="160" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('insights.createUserName')" prop="createUserName" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.createUserName || '-' }}</template>
        </el-table-column>
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('insights.adsetIdCol')" prop="adsetId" width="130" show-overflow-tooltip />
        <el-table-column v-if="activeDimension === 'ad'" :label="$t('insights.adIdCol')" prop="adId" min-width="140" show-overflow-tooltip />

        <!-- 用户维度列 -->
        <el-table-column v-if="activeDimension === 'user'" :label="$t('insights.createUserName')" prop="createUserName" min-width="160" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.createUserName || '未知' }}</template>
        </el-table-column>

        <!-- 指标列 -->
        <el-table-column :label="$t('insights.spend')" width="110" align="right" sortable="custom" prop="spend">
          <template slot-scope="{ row }">{{ formatMoney(row.spend) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.impressions')" width="100" align="right" sortable="custom" prop="impressions">
          <template slot-scope="{ row }">{{ formatInt(row.impressions) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.clicks')" width="90" align="right" sortable="custom" prop="clicks">
          <template slot-scope="{ row }">{{ formatInt(row.clicks) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.ctr')" width="90" align="right" sortable="custom" prop="ctr">
          <template slot-scope="{ row }">{{ formatPercent(row.ctr) }}</template>
        </el-table-column>
        <el-table-column label="CPM" width="100" align="right" sortable="custom" prop="cpm">
          <template slot-scope="{ row }">{{ formatMoney(row.cpm) }}</template>
        </el-table-column>
        <el-table-column label="CPC" width="100" align="right" sortable="custom" prop="cpc">
          <template slot-scope="{ row }">{{ formatMoney(row.cpc) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.purchases')" width="80" align="right" sortable="custom" prop="purchases">
          <template slot-scope="{ row }">{{ formatInt(row.purchases) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.costPerPurchase')" width="120" align="right" sortable="custom" prop="costPerPurchase">
          <template slot-scope="{ row }">{{ formatMoney(row.costPerPurchase) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.purchaseValue')" width="110" align="right" sortable="custom" prop="purchaseValue">
          <template slot-scope="{ row }">{{ formatMoney(row.purchaseValue) }}</template>
        </el-table-column>
        <el-table-column label="ROI" width="80" align="right" sortable="custom" prop="roi">
          <template slot-scope="{ row }">{{ formatDecimal(row.roi) }}</template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" fixed="right" width="100">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" icon="el-icon-data-analysis" @click="handleDaily(row)">{{ $t('insights.dailyDetail') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNo"
        :limit.sync="pageSize"
        @pagination="fetchData"
      />

      <!-- 汇总行 -->
      <div class="summary-row" v-if="tableData.length > 0">
        <span class="summary-label">全部汇总（共 {{ total }} 条）：</span>
        <span>{{ $t('insights.spend') }} <b>{{ formatMoney(summary.spend) }}</b></span>
        <span>{{ $t('insights.impressions') }} <b>{{ formatInt(summary.impressions) }}</b></span>
        <span>{{ $t('insights.clicks') }} <b>{{ formatInt(summary.clicks) }}</b></span>
        <span>{{ $t('insights.purchases') }} <b>{{ formatInt(summary.purchases) }}</b></span>
        <span>{{ $t('insights.purchaseValue') }} <b>{{ formatMoney(summary.purchaseValue) }}</b></span>
      </div>
    </el-card>

    <!-- 每日明细对话框 -->
    <el-dialog
      :title="dailyTitle"
      :visible.sync="dailyVisible"
      width="950px"
      append-to-body
    >
      <el-table
        ref="dailyTable"
        :data="dailyTableData"
        v-loading="dailyLoading"
        border
        size="small"
        :header-cell-style="{ background: '#f8fafd', color: '#606266', fontWeight: '600' }"
        @sort-change="handleDailySortChange"
      >
        <el-table-column prop="date" :label="$t('insights.date')" width="120" align="center" sortable="custom" />
        <el-table-column :label="$t('insights.spend')" width="100" align="right" prop="spend" sortable="custom">
          <template slot-scope="{ row }">{{ formatMoney(row.spend) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.impressionsShort')" width="100" align="right" prop="impressions" sortable="custom">
          <template slot-scope="{ row }">{{ formatInt(row.impressions) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.clicksShort')" width="90" align="right" prop="clicks" sortable="custom">
          <template slot-scope="{ row }">{{ formatInt(row.clicks) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.ctr')" width="80" align="right" prop="ctr" sortable="custom">
          <template slot-scope="{ row }">{{ formatPercent(row.ctr) }}</template>
        </el-table-column>
        <el-table-column label="CPM" width="90" align="right" prop="cpm" sortable="custom">
          <template slot-scope="{ row }">{{ formatMoney(row.cpm) }}</template>
        </el-table-column>
        <el-table-column label="CPC" width="90" align="right" prop="cpc" sortable="custom">
          <template slot-scope="{ row }">{{ formatMoney(row.cpc) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.purchases')" width="70" align="right" prop="purchases" sortable="custom">
          <template slot-scope="{ row }">{{ formatInt(row.purchases) }}</template>
        </el-table-column>
        <el-table-column :label="$t('insights.purchaseValue')" width="100" align="right" prop="purchaseValue" sortable="custom">
          <template slot-scope="{ row }">{{ formatMoney(row.purchaseValue) }}</template>
        </el-table-column>
        <el-table-column label="ROI" width="80" align="right" prop="roi" sortable="custom">
          <template slot-scope="{ row }">{{ formatDecimal(row.roi) }}</template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="dailyTotal > 0"
        :total="dailyTotal"
        :page.sync="dailyPageNo"
        :limit.sync="dailyPageSize"
        @pagination="() => {}"
        style="margin-top: 4px; padding: 0;"
      />
      <div slot="footer">
        <el-button @click="dailyVisible = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryInsightsAggPage, queryInsightsDaily, exportInsightsAgg, queryCreatorOptions } from '@/api/report/insights';
import { listStrategies } from '@/api/report/strategyAnalysis';
import { confirmExportLargeRows } from '@/utils/export';
import { withLocalDevLongRangeDateShortcuts } from '@/utils/dateRangePickerOptions';
import Pagination from '@/components/Pagination';

export default {
  name: 'InsightsReport',
  components: { Pagination },
  data() {
    return {
      loading: false,
      showSearch: true,
      activeDimension: 'account',
      dateRange: [],
      datePickerOptions: withLocalDevLongRangeDateShortcuts([
        { text: this.$t('insights.last7days'), onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 7); picker.$emit('pick', [s, e]); } },
        { text: this.$t('insights.last14days'), onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 14); picker.$emit('pick', [s, e]); } },
        { text: this.$t('insights.last30days'), onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 30); picker.$emit('pick', [s, e]); } }
      ]),
      creatorOptions: [],
      strategyList: [],
      showMetricFilter: false,
      ctrMinPct: undefined,
      ctrMaxPct: undefined,
      query: {
        adAccountId: undefined,
        campaignKeyword: undefined,
        bookName: undefined,
        adsetKeyword: undefined,
        adKeyword: undefined,
        userName: undefined,
        strategyId: undefined,
        startDate: undefined,
        endDate: undefined,
        spendMin: undefined,
        spendMax: undefined,
        purchasesMin: undefined,
        purchasesMax: undefined,
        costPerPurchaseMin: undefined,
        costPerPurchaseMax: undefined,
        purchaseValueMin: undefined,
        purchaseValueMax: undefined,
        roiMin: undefined,
        roiMax: undefined
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      globalSummary: null,
      sortField: 'spend',
      sortOrder: 'desc',
      dailyVisible: false,
      dailyLoading: false,
      dailyTitle: '',
      dailyAllList: [],
      dailyPageNo: 1,
      dailyPageSize: 10,
      dailySortField: 'date',
      dailySortOrder: 'asc',
      exporting: false
    };
  },
  computed: {
    isDataLimited() {
      var appVm = this.$root && this.$root.$children && this.$root.$children[0];
      var user = appVm && appVm.currentUser;
      if (!user || !user.roleCodes) return false;
      return user.roleCodes.indexOf('data_limited') !== -1;
    },
    summary() {
      const s = this.globalSummary;
      if (s) {
        return {
          spend: Number(s.spend) || 0,
          impressions: Number(s.impressions) || 0,
          clicks: Number(s.clicks) || 0,
          purchases: Number(s.purchases) || 0,
          purchaseValue: Number(s.purchase_value) || 0
        };
      }
      // 后端未返回时降级为当前页求和
      let spend = 0, impressions = 0, clicks = 0, purchases = 0, purchaseValue = 0;
      for (const row of this.tableData) {
        spend += Number(row.spend) || 0;
        impressions += Number(row.impressions) || 0;
        clicks += Number(row.clicks) || 0;
        purchases += Number(row.purchases) || 0;
        purchaseValue += Number(row.purchaseValue) || 0;
      }
      return { spend, impressions, clicks, purchases, purchaseValue };
    },
    dailyTotal() {
      return this.dailyAllList.length;
    },
    dailyTableData() {
      const sorted = [...this.dailyAllList].sort((a, b) => {
        let va = a[this.dailySortField];
        let vb = b[this.dailySortField];
        const na = Number(va);
        const nb = Number(vb);
        if (!isNaN(na) && !isNaN(nb)) { va = na; vb = nb; }
        const cmp = va > vb ? 1 : va < vb ? -1 : 0;
        return this.dailySortOrder === 'asc' ? cmp : -cmp;
      });
      const start = (this.dailyPageNo - 1) * this.dailyPageSize;
      return sorted.slice(start, start + this.dailyPageSize);
    }
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 6);
    const fmt = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    this.dateRange = [fmt(start), fmt(end)];
    this.query.startDate = fmt(start);
    this.query.endDate = fmt(end);
    this.loadFilterOptions();
    this.fetchData();
  },
  methods: {
    loadFilterOptions() {
      queryCreatorOptions().then(function(res) {
        this.creatorOptions = res.data || [];
      }.bind(this));
      listStrategies().then(function(res) {
        this.strategyList = res.data || [];
      }.bind(this));
    },
    resolveKeyword(keyword) {
      if (!keyword || !keyword.trim()) return { id: undefined, name: undefined };
      const v = keyword.trim();
      if (/^\d+$/.test(v)) return { id: v, name: undefined };
      return { id: undefined, name: v };
    },
    buildFilterParams() {
      const campaign = this.resolveKeyword(this.query.campaignKeyword);
      const adset = this.resolveKeyword(this.query.adsetKeyword);
      const ad = this.resolveKeyword(this.query.adKeyword);
      return {
        dimension: this.activeDimension,
        startDate: this.query.startDate,
        endDate: this.query.endDate,
        adAccountId: this.query.adAccountId,
        campaignId: campaign.id,
        campaignName: campaign.name,
        bookName: this.query.bookName,
        adsetId: adset.id,
        adsetName: adset.name,
        adId: ad.id,
        adNameKeyword: ad.name,
        userName: this.query.userName,
        strategyId: this.query.strategyId,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        spendMin: this.query.spendMin,
        spendMax: this.query.spendMax,
        purchasesMin: this.query.purchasesMin,
        purchasesMax: this.query.purchasesMax,
        costPerPurchaseMin: this.query.costPerPurchaseMin,
        costPerPurchaseMax: this.query.costPerPurchaseMax,
        purchaseValueMin: this.query.purchaseValueMin,
        purchaseValueMax: this.query.purchaseValueMax,
        roiMin: this.query.roiMin,
        roiMax: this.query.roiMax
      };
    },
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          ...this.buildFilterParams(),
          pageNo: this.pageNo,
          pageSize: this.pageSize
        };
        if (this.ctrMinPct != null) params.ctrMin = this.ctrMinPct / 100;
        if (this.ctrMaxPct != null) params.ctrMax = this.ctrMaxPct / 100;
        const res = await queryInsightsAggPage(params);
        const pageData = res.data || {};
        this.tableData = pageData.records || [];
        this.total = pageData.total || 0;
        this.globalSummary = pageData.summary || null;
      } finally {
        this.loading = false;
      }
    },
    handleQuery() {
      this.pageNo = 1;
      this.fetchData();
    },
    resetQuery() {
      const end = new Date();
      end.setDate(end.getDate() - 1);
      const start = new Date();
      start.setDate(start.getDate() - 7);
      const fmt = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      this.dateRange = [fmt(start), fmt(end)];
      this.query = {
        adAccountId: undefined,
        campaignKeyword: undefined,
        bookName: undefined,
        adsetKeyword: undefined,
        adKeyword: undefined,
        userName: undefined,
        strategyId: undefined,
        startDate: fmt(start),
        endDate: fmt(end),
        spendMin: undefined,
        spendMax: undefined,
        purchasesMin: undefined,
        purchasesMax: undefined,
        costPerPurchaseMin: undefined,
        costPerPurchaseMax: undefined,
        purchaseValueMin: undefined,
        purchaseValueMax: undefined,
        roiMin: undefined,
        roiMax: undefined
      };
      this.ctrMinPct = undefined;
      this.ctrMaxPct = undefined;
      this.pageNo = 1;
      this.sortField = 'spend';
      this.sortOrder = 'desc';
      this.fetchData();
    },
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.query.startDate = val[0];
        this.query.endDate = val[1];
      } else {
        this.query.startDate = undefined;
        this.query.endDate = undefined;
      }
    },
    handleTabChange() {
      if (this.activeDimension !== 'account' && this.sortField === 'accountBalance') {
        this.sortField = 'spend';
        this.sortOrder = 'desc';
      }
      this.pageNo = 1;
      this.fetchData();
    },
    handleSortChange({ prop, order }) {
      if (!order) {
        this.sortField = 'spend';
        this.sortOrder = 'desc';
      } else {
        this.sortField = prop || 'spend';
        this.sortOrder = order === 'ascending' ? 'asc' : 'desc';
      }
      this.pageNo = 1;
      this.fetchData();
    },
    handleDailySortChange({ prop, order }) {
      this.dailySortField = prop || 'date';
      this.dailySortOrder = order === 'ascending' ? 'asc' : 'desc';
      this.dailyPageNo = 1;
    },
    async handleExport() {
      this.$confirm('确认导出当前筛选条件下的数据？', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const countParams = { ...this.buildFilterParams(), pageNo: 1, pageSize: 1 };
        if (this.ctrMinPct != null) countParams.ctrMin = this.ctrMinPct / 100;
        if (this.ctrMaxPct != null) countParams.ctrMax = this.ctrMaxPct / 100;
        let countRes;
        try {
          countRes = await queryInsightsAggPage(countParams);
        } catch (e) {
          this.$message.error(this.$t('common.exportCountFail'));
          return;
        }
        try {
          await confirmExportLargeRows(this, (countRes.data || {}).total || 0);
        } catch (e) {
          return;
        }
        this.exporting = true;
        try {
          const params = { ...this.buildFilterParams() };
          if (this.ctrMinPct != null) params.ctrMin = this.ctrMinPct / 100;
          if (this.ctrMaxPct != null) params.ctrMax = this.ctrMaxPct / 100;
          const res = await exportInsightsAgg(params);
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '消耗明细报表.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message.success('导出成功');
        } catch (e) {
          this.$message.error('导出失败');
        } finally {
          this.exporting = false;
        }
      }).catch(() => {});
    },
    async handleDaily(row) {
      let objectId;
      let titleParts = [];
      if (this.activeDimension === 'account') {
        objectId = row.adAccountId;
        titleParts.push(this.$t('insights.prefixAccount') + row.adAccountId);
      } else if (this.activeDimension === 'campaign') {
        objectId = row.objectId;
        titleParts.push(this.$t('insights.prefixCampaign') + row.campaignId);
      } else if (this.activeDimension === 'adset') {
        objectId = row.objectId;
        titleParts.push(this.$t('insights.prefixAdset') + row.adsetId);
      } else if (this.activeDimension === 'user') {
        objectId = row.objectId;
        titleParts.push(this.$t('insights.prefixUser') + row.createUserName);
      } else {
        objectId = row.objectId;
        titleParts.push(this.$t('insights.prefixAd') + row.adId);
      }
      this.dailyTitle = this.$t('insights.dailyTitle') + titleParts.join(' / ');
      this.dailyVisible = true;
      this.dailyLoading = true;
      this.dailyAllList = [];
      this.dailyPageNo = 1;
      this.dailySortField = 'date';
      this.dailySortOrder = 'asc';
      this.$nextTick(() => {
        this.$refs.dailyTable && this.$refs.dailyTable.clearSort();
      });
      try {
        const params = {
          dimension: this.activeDimension,
          objectId: objectId,
          startDate: this.query.startDate,
          endDate: this.query.endDate
        };
        const res = await queryInsightsDaily(params);
        this.dailyAllList = res.data || [];
      } finally {
        this.dailyLoading = false;
      }
    },
    formatMoney(val) {
      if (val == null) return '-';
      return Number(val).toFixed(2);
    },
    formatDecimal(val) {
      if (val == null) return '-';
      return Number(val).toFixed(4);
    },
    formatPercent(val) {
      if (val == null) return '-';
      return (Number(val) * 100).toFixed(2) + '%';
    },
    formatInt(val) {
      if (val == null) return '-';
      return Number(val).toLocaleString();
    }
  }
};
</script>

<style scoped>
.summary-row {
  margin-top: 12px;
  padding: 10px 16px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}
.summary-label {
  font-weight: 600;
  color: #303133;
}
.summary-row b {
  color: #409EFF;
}
.metric-filter-row {
  background: #fafbfc;
  padding: 8px 16px;
  border-radius: 4px;
  margin-bottom: 8px;
}
.range-sep {
  margin: 0 4px;
  color: #999;
}
.range-unit {
  margin-left: 2px;
  color: #999;
  font-size: 12px;
}
</style>
